import {
  SAVE_BEACON_FAILURE,
  SAVE_BEACON_SUCCESS,
  SAVE_BEACON_REQUEST,
  FETCH_BEACONS_REQUEST,
  FETCH_BEACONS_SUCCESS,
  FETCH_BEACONS_FAILURE,
  FETCH_BEACON_REQUEST,
  FETCH_BEACON_SUCCESS,
  FETCH_BEACON_FAILURE,
  FETCH_BEACON_IMAGE_REQUEST,
  FETCH_BEACON_IMAGE_SUCCESS,
  FETCH_BEACON_IMAGE_FAILURE,
  FETCH_BEACON_COMPLETE_REQUEST,
  FETCH_BEACON_COMPLETE_SUCCESS,
  FETCH_BEACON_COMPLETE_FAILURE,
  FETCH_SIMPLE_BEACON_LIST_PDF_REQUEST,
  FETCH_SIMPLE_BEACON_LIST_PDF_SUCCESS,
  FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE,
  FETCH_CUSTOM_BEACON_LIST_PDF_REQUEST,
  FETCH_CUSTOM_BEACON_LIST_PDF_SUCCESS,
  FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE,
} from '../types';

const INITIAL_STATE = {
  beacons: [],
  beacon: null,
  beaconComplete: null,
  loading: false,
  error: null,
  simplepBeaconList: null,
  simplepBeaconListLoading: false,
  custompBeaconList: null,
  custompBeaconListLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BEACONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BEACONS_SUCCESS:
      return {
        ...state,
        loading: false,
        beacons: action.payload,
      };

    case FETCH_BEACONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        beacons: [],
      };
    case SAVE_BEACON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_BEACON_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_BEACON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_BEACON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BEACON_SUCCESS:
      return {
        ...state,
        loading: false,
        beacon: action.payload,
      };

    case FETCH_BEACON_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        beacon: null,
      };
    case FETCH_BEACON_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BEACON_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        beaconImageUrl: action.payload,
      };

    case FETCH_BEACON_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        beaconImageUrl: '',
      };
    case FETCH_BEACON_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BEACON_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        beaconComplete: action.payload,
      };

    case FETCH_BEACON_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        beaconComplete: null,
      };
    case FETCH_SIMPLE_BEACON_LIST_PDF_REQUEST:
      return {
        ...state,
        simplepBeaconListLoading: true,
        error: null,
      };

    case FETCH_SIMPLE_BEACON_LIST_PDF_SUCCESS:
      return {
        ...state,
        simplepBeaconListLoading: false,
        simplepBeaconList: action.payload,
      };

    case FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE:
      return {
        ...state,
        simplepBeaconListLoading: false,
        error: action.payload.error,
        simplepBeaconList: null,
      };

    case FETCH_CUSTOM_BEACON_LIST_PDF_REQUEST:
      return {
        ...state,
        custompBeaconListLoading: true,
        error: null,
      };

    case FETCH_CUSTOM_BEACON_LIST_PDF_SUCCESS:
      return {
        ...state,
        custompBeaconListLoading: false,
        custompBeaconList: action.payload,
      };

    case FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE:
      return {
        ...state,
        custompBeaconListLoading: false,
        error: action.payload.error,
        custompBeaconList: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
